import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import cn from 'classnames';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { elmoSaysThisMightBeADeviationUrl } from '../../../utils/deviations';
import s from './DeviationLink.scss';
function isInternalLink(url) {
    return /^https:\/\/www\.deviantart\.com/.test(url) || /^#/.test(url) || elmoSaysThisMightBeADeviationUrl(url);
}
export function findAndScrollTo(id, isMobile) {
    const el = document.getElementById(id.replace(/^#/, ''));
    if (el) {
        scrollIntoViewWithHeader(el, isMobile, undefined, undefined, true, true);
    }
}
const getUrl = (url)=>{
    if (!url) {
        return url;
    }
    if (!/^https?/.test(url)) {
        return `https://${url}`;
    }
    return url;
};
const EditorDeviationLink = ({ className, style, link, deviation, children })=>{
    const isMobile = useContext(MobileContext);
    const linkProps = {
        className: cn(s['link'], className),
        style
    };
    if (link) {
        link = link.trim();
        if (/^#[a-z-0-9]+$/i.test(link)) {
            return /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
                href: link,
                onClick: (e)=>{
                    e.preventDefault();
                    findAndScrollTo(link, isMobile);
                },
                rel: "noopener ugc noreferrer"
            }), children);
        }
        return /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
            href: getUrl(cleanLinkSrc(link)),
            rel: "noopener ugc noreferrer",
            target: isInternalLink(getUrl(cleanLinkSrc(link))) ? undefined : '_blank'
        }), children);
    }
    return /*#__PURE__*/ React.createElement(DeviationLink, _object_spread_props(_object_spread({}, linkProps), {
        deviation: deviation,
        canLinkToStash: deviation.isJournal
    }), children);
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;

//# sourceMappingURL=DeviationLink.js.map